import { Sap } from "@/abilities/shop/types/sap-shop";
import { useGetConfigSapShopLazyQuery } from "@/shared/services/graphql/generated/consumer-graph-types";

export const loadSapShopConfig = async (): Promise<Sap.Config | null> => {
    const { load } = useGetConfigSapShopLazyQuery();
    const data = await load();
    if (data && data.getSapShopConfig) {
        const { graphUrl, id, shopServiceUrl, shopUrl, appEntryParameter, cartIdParameter } = data.getSapShopConfig;
        if (!graphUrl || !id || !shopServiceUrl || !shopUrl || !cartIdParameter || !appEntryParameter) {
            return null;
        }
        return {
            graphUrl,
            id,
            shopServiceUrl,
            shopUrl,
            cartIdParameter,
            appEntryParameter,
        };
    } else {
        return null;
    }
};
